import { Box, CircularProgress } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';

const RenewSubscriptionLanding = lazy(() => import('pages/renew-subscription-landing'));

const Loader = (): JSX.Element => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress />
  </Box>
);

export const Route = createFileRoute('/_authenticated/_landing/renew-subscription')({
  component: RenewSubscriptionWrapper,
});

function RenewSubscriptionWrapper(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <RenewSubscriptionLanding />
    </Suspense>
  );
}
